import react, {useContext} from "react"
import styles from "./Footer.module.css"
import "./Footer_global.css"
import {Context} from "../../index";
import {observer} from "mobx-react-lite";

function Footer(){
    const {store} = useContext(Context)
    return (
        <>
        <div className="footer_main">


            <div className="links">

                    <a href="/page/GR">Gambling with responsibility</a>
                    <a href="/page/PRP">Privacy Policy</a>
                    <a href="/page/TU">Terms of use</a>
                    <a href="/page/KYC">KYC</a>
                    <a href="/page/AML">AML</a>
                <a href="/page/TC">Terms and Conditions</a>
                <a href="/page/RG">Responsible Gaming</a>


            </div>

        </div>
            <div className={styles.wrapperContainer}>
                <div className={styles.containerWarring}>
                    <div className={styles.block18}>
                        18+
                    </div>
                    <div className={styles.text}>{store.dataLang["warring_text_azart"]}</div>
                </div>
                <div className={styles.containerOurContacts}>
                    <div className={styles.textContact}>support@snake.money</div>

                    <div className={styles.textContact}><a href="https://t.me/snake_money_w" target="_blank">Telegram</a></div>
                </div>
            </div>
        </>
    )
}
export default observer(Footer)